import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { HappyToCare } from 'Components/widgets/happy-to-care/HappyToCare';
type Props = {
  id?: string;
  businessSocialResponsibility?: {
    title: string;
    items: Array<{
      description: string;
      imageUrl: string;
      title: string;
    }>;
  };
  seeMoreLink?: string;
};
export const HappyToCareLine = ({ id, seeMoreLink, businessSocialResponsibility }: Props) => {
  const { isTablet } = useResponsive();

  if (!businessSocialResponsibility?.items?.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" data-testid="happyToCare" id={id} isWide={!isTablet}>
      <HappyToCare {...businessSocialResponsibility} className="mt-80 md:mt-0" url={seeMoreLink} />
    </SiteContainer>
  );
};
